var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeManagmentMultiLevelImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1185 0C25.4789 0 24.9763 0.500758 24.9763 1.13636C24.9763 1.77197 25.4789 2.27273 26.1185 2.27273C26.7581 2.27273 27.2607 1.77197 27.2607 1.13636C27.2607 0.500758 26.7581 0 26.1185 0ZM28.2816 3.82803L20.415 5.37879L28.2816 6.93182V3.82803ZM25.4332 8.0303V30.1515H28.4339V8.37121L25.4332 8.0303ZM24.3671 31.5152V35H29.5V31.5152H24.3671Z",
    fill: "url(#paint0_linear_441_1308)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4076 34.849H14.5768V11.3145H20.4076V34.849ZM16.0345 33.398H18.9499V12.7655H16.0345V33.398ZM13.1191 34.849H7.28841V18.4473H13.1191V34.849ZM5.83073 34.849H0V26.1427H5.83073V34.849Z",
    fill: "url(#paint1_linear_441_1308)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_1308",
    x1: 24.1425,
    y1: 0,
    x2: 24.1425,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_441_1308",
    x1: 10.2038,
    y1: 11.3145,
    x2: 10.2038,
    y2: 34.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeManagmentMultiLevelImg);
export default __webpack_public_path__ + "static/media/change_managment_multi-Level-img.c12a8f76a54d55a7087e51b3cec98589.svg";
export { ForwardRef as ReactComponent };